import React, { useEffect } from "react";
import { Typography } from '@material-ui/core';
import FormScopeDefiner from "../../../../Component/Forms/FormScopeDefiner";
import ThemeControls from "../../../../Component/AllThemesControl";
import contextJson from './masterJson.json';
import fieldsData from './viewTableColumn.json';
import Control from '../../../../FormsControls/Control'

function Create() {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const contextClasses = classes.topSpace;
  const contextObjective = "create";
  const apiContextObj = fieldsData.config;
  let sideImageData = {};
  const {SubForm}=Control;
  const {field_id,field_parent_class,field_parent_style,field_label_class,field_label_style,field_self_class,field_self_style,id,field_unique,field_disabled_Edit,field_apipath,fields,field_pastDisable,field_disabled,field_label,field_type,field_placeholder,field_value,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_minvalue,field_value_type,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_minlength,field_error_msg_required,field_error_msg_uq,field_mandatory}=contextJson
  // useEffect(()=>{
  //   Object.keys(contextJson).forEach((key, index) => {
  //     if (key !== "xioFEConfig") {
  //       contextJson[key].fields.map((field) => {
  //         if (field.field_type === "custom") {
  //           field.field_value = "{}";
  //         } else if (field.field_default_value) {
  //           field.field_value = field.field_default_value
  //           field.id = ""
  //           field.field_helperText = ""
  //         } else {
  //           field.field_value = "";
  //           field.field_helperText = "";
  //           field.id = "";
  //         }
  //         return field; // <-- add this return statement
  //       });
  
  //       // =---sideIMage---dataAssing--->
  //       if (contextJson['xioFEConfig'] && contextJson['xioFEConfig'].sideImageData) {
  //         sideImageData = contextJson['xioFEConfig'].sideImageData;
  //       }
  //     }
  //   });
  // },[])


  return (
    <div className={classes.main}>
      {/* <PolicyImg Image={smsPolicyImg} data={sideImageData}/>  */}
      <div className={classes.formAline}>
        {/* <Typography variant="h6" className={classes.marginChange}>
          {contextHeading}
        </Typography> */}
        <SubForm
                field_id={field_id}
                field_parent_class={field_parent_class}
                field_parent_style={field_parent_style}
                field_label_class={field_label_class}
                field_label_style={field_label_style}
                field_self_class={field_self_class}
                field_self_style={field_self_style}
                id={id}
                field_unique={field_unique}
                field_disabled_Edit={field_disabled_Edit}
                field_apipath={field_apipath}
                fields={fields}
                field_pastDisable={field_pastDisable}
                field_disabled={field_disabled}
                field_label={field_label}
                field_type={field_type}
                field_placeholder={field_placeholder}
                field_value={field_value}
                field_helperText={field_helperText}
                field_minlength={field_minlength}
                field_maxlength={field_maxlength}
                field_maxvalue={field_maxvalue}
                field_minvalue={field_minvalue}
                field_value_type={field_value_type}
                field_error_msg_maxlength={field_error_msg_maxlength}
                field_error_msg_minvalue={field_error_msg_minvalue}
                field_error_msg_maxvalue={field_error_msg_maxvalue}
                field_error_msg_minlength={field_error_msg_minlength}
                field_error_msg_required={field_error_msg_required}
                field_error_msg_uq={field_error_msg_uq}
                field_mandatory={field_mandatory}
            />
        {/* <FormScopeDefiner value={{ contextJson, apiContextObj,   contextClasses, contextObjective }}>
        </FormScopeDefiner> */}
      </div>
    </div>
  )
}

export default Create;
